import { useState, useEffect } from 'react';
import axios from 'axios';

const Home = () => {
    const [codigoUnico, setCodigoUnico] = useState('');
  
    useEffect(() => {
      // Función para generar o recuperar el código único del localStorage
      const generarORecuperarCodigoUnico = () => {
        let codigo = localStorage.getItem('codigoUnico');
        if (!codigo) {
          // Genera un código único si no está configurado
          codigo = generarCodigoUnico();
          localStorage.setItem('codigoUnico', codigo);
        }
        return codigo;
      };
  
      // Función para generar el código único
      const generarCodigoUnico = () => {
        const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const longitud = 5;
        let codigo = '';
        for (let i = 0; i < longitud; i++) {
          codigo += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
        }
        return codigo;
      };
  
      // Establece el código único en el estado si aún no está configurado
      if (!codigoUnico) {
        setCodigoUnico(generarORecuperarCodigoUnico());
      }
  
      // Limpia el intervalo cuando el componente se desmonta
 
    }, [codigoUnico]);
  return (
    <div className="flex place-content-center items-center min-h-screen bg-[#0F172A]">
  <div className="hero-content text-center">
    <div>
      <h1 className="text-5xl font-bold whitespace-nowrap">Listo para transmitir</h1>
      <p className="pt-5 text-xl">Tú código de dispositivo es: <b>{codigoUnico}</b>
      
      </p>
      <p className="pt-2 text-xl">No compartas el código con desconocidos.
      </p>
      
    </div>
  </div>
</div>
  );
};

export default Home;